import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getModules = () => client.get("/modules").then((r) => r.data);
export const getModuleClaims = (id) =>
  client.get(`/modules/${id}/claims`).then((r) => r.data);
export const getSession = (id) => client.get(`/sessions/${id}`).then((r) => r.data);
export const createSession = (trainee_name, module_id) =>
  client.post("/sessions", { trainee_name, module_id }).then((r) => r.data);
export const submitAnswer = (sessionId, claim_id, decision) =>
  client
    .post(`/sessions/${sessionId}/answer`, { claim_id, decision })
    .then((r) => r.data);
export const completeSession = (sessionId) =>
  client.post(`/sessions/${sessionId}/complete`).then((r) => r.data);
export const getGlobalLeaderboard = () =>
  client.get("/leaderboard/global").then((r) => r.data);
export const getModuleLeaderboard = (id) =>
  client.get(`/leaderboard/module/${id}`).then((r) => r.data);
